/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Dispatch, SetStateAction, useState } from "react";
import { Box, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import RejectReasonModal from "../../Modals/rejectReason";
import CustomPagination from "../../components/CustomPagination";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import dayjs, { Dayjs } from "dayjs";
import StarIcon from "@mui/icons-material/Star";
import { MEMBER_SORTING } from "../../utils/enums";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { formatDubaiDateTime } from "../../utils/dateTime";

const CustomerListRejected = ({
  data,
  hasFetched,
  count,
  page,
  setPage,
  sortOrder,
  setSortOrder,
}: {
  data: any;
  hasFetched: boolean;
  count: number;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  sortOrder: string;
  setSortOrder: Dispatch<SetStateAction<string>>;
}) => {
  const navigate = useNavigate();

  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);
  const [reason, setReason] = useState("");

  const toggleExpand = (id: number) => {
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => setOpen(false);

  return (
    <>
      <div className="sorting_table cards table_cards">
        <div className="table_container">
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}
          >
            <thead>
              <tr>
                <th>
                  {" "}
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Name
                    <SwapVertIcon
                      onClick={() =>
                        setSortOrder(
                          sortOrder === MEMBER_SORTING.Name_asc
                            ? "Name_desc"
                            : "Name_asc"
                        )
                      }
                    />
                  </div>
                </th>
                <th className="email_data">
                  {" "}
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Email
                    <SwapVertIcon
                      onClick={() =>
                        setSortOrder(
                          sortOrder === MEMBER_SORTING.Email_asc
                            ? "Email_desc"
                            : "Email_asc"
                        )
                      }
                    />
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Membership Type
                    <SwapVertIcon
                      onClick={() =>
                        setSortOrder(
                          sortOrder === MEMBER_SORTING.MembershipType_asc
                            ? "MembershipType_desc"
                            : "MembershipType_asc"
                        )
                      }
                    />
                  </div>
                </th>
                <th>
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Created Date
                    <SwapVertIcon
                      onClick={() =>
                        setSortOrder(
                          sortOrder === MEMBER_SORTING.DateCreated_asc
                            ? "DateCreated_desc"
                            : "DateCreated_asc"
                        )
                      }
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.length ? (
                data?.map((row: any) => (
                  <React.Fragment key={row?.id}>
                    <tr>
                      <td>
                        <div
                          role="button"
                          tabIndex={0}
                          className="user_block click_action"
                          onClick={() =>
                            navigate(`/manage-customers/detail/${row?.id}`, {
                              state: {
                                status: "REJECTED",
                                memberType: row?.membershipType,
                              },
                            })
                          }
                        >
                          {row?.isVIP ? <StarIcon /> : null}
                          <figure>
                            <img
                              src="/static/images/user_placeholder.png"
                              alt=""
                            />
                          </figure>
                          <p>
                            <b>{row?.name || "-"}</b>
                          </p>
                        </div>
                      </td>
                      <td className="email_data">{row?.email || "-"}</td>
                      <td>
                        {row?.membershipType}
                        {row?.membershipType === "Duo" && (
                          <IconButton
                            className="d_active"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevents triggering parent navigation if added
                              toggleExpand(row.id);
                            }}
                            size="small"
                            style={{ verticalAlign: "middle", marginLeft: 4 }}
                          >
                            {expandedRowId === row?.id ? (
                              <ArrowDropDownIcon
                                style={{ transform: "rotate(180deg)" }}
                              />
                            ) : (
                              <ArrowDropDownIcon />
                            )}
                          </IconButton>
                        )}
                      </td>
                      <td>
                        {row?.createdDate
                          ? formatDubaiDateTime(row?.createdDate)
                          : "-"}
                      </td>
                    </tr>

                    {expandedRowId === row.id && (
                      <tr>
                        <td colSpan={4}>
                          <div className="expanded-content p_inline_0">
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                tableLayout: "fixed",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td>
                                    <div
                                      role="button"
                                      tabIndex={0}
                                      className="user_block click_action"
                                      onClick={() =>
                                        navigate(
                                          `/manage-customers/detail/${row?.id}`,
                                          {
                                            state: {
                                              status: "REJECTED",
                                              memberType: row?.membershipType,
                                            },
                                          }
                                        )
                                      }
                                    >
                                      {row?.isVIP ? <StarIcon /> : null}
                                      <figure>
                                        <img
                                          src="/static/images/user_placeholder.png"
                                          alt=""
                                        />
                                      </figure>
                                      <p>
                                        <b>{row?.name || "-"}</b>
                                      </p>
                                    </div>
                                  </td>
                                  <td className="email_data">
                                    {row?.email || "-"}
                                  </td>
                                  <td>{row?.membershipType || "-"}</td>
                                  <td>
                                    {" "}
                                    {dayjs(row?.createdDate).format(
                                      "DD - MMMM - YYYY  |  hh:mm A"
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              ) : hasFetched ? (
                <tr>
                  <td
                    colSpan={4}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No Data Found
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
      {data?.length ? (
        <CustomPagination
          currentPage={page - 1}
          totalPages={Math.ceil(count / 10)}
          count={count}
          pageSize={10}
          onPageChange={(page) => setPage(page + 1)}
        />
      ) : null}

      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
        onClick={() => setOpen(false)}
        setReason={setReason}
        reason={reason}
      />
    </>
  );
};

export default CustomerListRejected;
